<template><div><h1 id="benutzerhandbuch" tabindex="-1"><a class="header-anchor" href="#benutzerhandbuch"><span>Benutzerhandbuch</span></a></h1>
<p>Der Teil Benutzerhandbuch gibt zuerst eine Einführung und einen Überblick über funtrade. In den folgenden Kapiteln sind Anleitungen und Erklärungen zu den häufigsten Geschäftsprozessen vorhanden.</p>
</div></template>


